import React from 'react';
import { useNavigate } from 'react-router-dom';
import { ShieldCheck, ArrowLeft } from 'lucide-react';

// REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
const Login = () => {
  const navigate = useNavigate();

  const onLogin = () => {
    const redirectUrl = window.location.origin + '/admin/callback';
    window.location.href = `https://auth.emergentagent.com/?redirect=${encodeURIComponent(redirectUrl)}`;
  };

  return (
    <div className="min-h-screen marble-bg flex items-center justify-center p-6">
      <div className="max-w-md w-full bg-white border border-[#E8E2D5] p-10 md:p-12 relative">
        <button onClick={() => navigate('/')} className="absolute top-6 left-6 text-[10px] tracking-[0.3em] uppercase text-[#8A8275] hover:text-[#957340] flex items-center gap-2">
          <ArrowLeft size={12} /> Retour
        </button>

        <div className="text-center mt-6">
          <div className="w-12 h-12 border border-[#1A1A1A] flex items-center justify-center mx-auto">
            <span className="display text-[22px] leading-none">D</span>
          </div>
          <div className="display text-[24px] tracking-wide mt-4">DEVIL TATTOOZ</div>
          <div className="text-[9px] tracking-[0.32em] uppercase text-[#8A8275] mt-1">Administration</div>

          <div className="gold-line my-8 w-24 mx-auto" />

          <h1 className="h-display text-[32px] leading-tight">Connexion sécurisée.</h1>
          <p className="text-[14px] text-[#3A3A3A] mt-3 leading-[1.7]">
            Connectez-vous avec votre compte Google pour accéder à l’interface d’administration.
          </p>

          <button onClick={onLogin} className="btn-primary w-full justify-center mt-8">
            <svg width="16" height="16" viewBox="0 0 24 24" fill="currentColor"><path d="M22.56 12.25c0-.78-.07-1.53-.2-2.25H12v4.26h5.92c-.26 1.37-1.04 2.53-2.21 3.31v2.77h3.57c2.08-1.92 3.28-4.74 3.28-8.09z" fill="#fff"/><path d="M12 23c2.97 0 5.46-.98 7.28-2.66l-3.57-2.77c-.98.66-2.23 1.06-3.71 1.06-2.86 0-5.29-1.93-6.16-4.53H2.18v2.84A10.997 10.997 0 0 0 12 23z" fill="#fff"/><path d="M5.84 14.09c-.22-.66-.35-1.36-.35-2.09s.13-1.43.35-2.09V7.07H2.18A10.997 10.997 0 0 0 1 12c0 1.77.43 3.45 1.18 4.93l3.66-2.84z" fill="#fff"/><path d="M12 5.38c1.62 0 3.06.56 4.21 1.64l3.15-3.15C17.45 2.09 14.97 1 12 1 7.7 1 3.99 3.47 2.18 7.07l3.66 2.84c.87-2.6 3.3-4.53 6.16-4.53z" fill="#fff"/></svg>
            Continuer avec Google
          </button>

          <div className="flex items-center gap-2 justify-center mt-6 text-[10px] tracking-[0.28em] uppercase text-[#8A8275]">
            <ShieldCheck size={12} className="text-[#957340]" />
            Accès réservé à l’administrateur
          </div>
        </div>
      </div>
    </div>
  );
};

export default Login;
